import { format } from 'date-fns';
import { ORDER_STATUSES, PAYMENT_STATUSES, SHIPPING_STATUSES, STATUS_LABELS, getStatusVariant } from '../constants';

export const APP_CONFIG = {
    defaultCurrency: 'INR',
    currencySymbol: '₹',
    currencyPosition: 'prefix',
    dateTimeFormats: {
        display: 'dd/MM/yyyy hh:mm:ss a',
        sql: 'yyyy-MM-dd HH:mm:ss',
    }
};

export const formatCurrency = (value) => {
    const { currencySymbol, currencyPosition } = APP_CONFIG;
    const num = parseFloat(value);
    if (isNaN(num)) return `${currencySymbol}0.00`;
    const formattedValue = num.toFixed(2);
    if (currencyPosition === 'prefix') {
        return `${currencySymbol}${formattedValue}`;
    }
    return `${formattedValue}${currencySymbol}`;
};

export const formatDateTime = (date) => {
    if (!date) return 'N/A';
    try {
        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime())) return 'Invalid Date';
        return format(parsedDate, APP_CONFIG.dateTimeFormats.display);
    } catch (error) {
        return 'Invalid Date';
    }
};
export const formatDateToSQL = (date) => {
    if (!date) return null;
    try {
        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime())) return null;
        return format(parsedDate, APP_CONFIG.dateTimeFormats.sql);
    } catch (error) {
        return null;
    }
};

export const renderStatusBadge = (status = '') => {
    const normalizedStatus = status.trim().toLowerCase();
    const variant = getStatusVariant(normalizedStatus) || 'secondary';
    const displayText = STATUS_LABELS[normalizedStatus] || status;
    return `<span class="badge bg-${variant}">${displayText}</span>`;
};

export const renderPaymentStatusBadge = (status = '') => {
    const normalizedStatus = status.trim().toLowerCase();
    const variant = getStatusVariant(normalizedStatus) || 'secondary';
    const displayText = STATUS_LABELS[normalizedStatus] || status;
    return `<span class="badge bg-${variant}">${displayText}</span>`;
};

export const getTotalItems = (orderItems) =>
    orderItems.reduce((sum, item) => sum + item.quantity, 0);

export const capitalize = (text) =>
    typeof text === 'string' ? text.charAt(0).toUpperCase() + text.slice(1) : text;

export const formatBoolean = (value) => (value ? 'Yes' : 'No');

export const idFormat = (id) => (
    <span className="badge bg-danger-subtle rounded-0 text-dark">#{id}</span>
);

const states = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  'Delhi',
  'Lakshadweep',
  'Puducherry',
  'Ladakh',
  'Jammu & Kashmir',
  'Chandigarh',
  'Andaman and Nicobar Islands',
  'Dadra and Nagar Haveli and Daman and Diu'
];

export const stateOptions = states.reduce((acc, state) => {
  acc[''] = 'select';
  acc[state] = state;
  return acc;
}, {});

const countries = [
  'India'
];

export const countryOptions = countries.reduce((acy, country) => {
  acy[''] = 'select';
  acy[country] = country;
  return acy;
}, {});